import { Plus } from 'lucide-react';

export default function FloatingActionButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="md:hidden fixed bottom-24 right-4 z-40 w-14 h-14 rounded-full bg-brand-600 hover:bg-brand-700 text-white shadow-lg hover:shadow-xl flex items-center justify-center transition-all active:scale-95"
      aria-label="Add transaction"
    >
      <Plus size={24} />
    </button>
  );
}
